import { createFileRoute } from '@tanstack/react-router';

import { outreachSearchSchema } from '@apps/web/components/admin/outreach_observability/outreach_search';

export const Route = createFileRoute('/_app/admin/outreach-observability')({
    validateSearch: outreachSearchSchema,
    head: () => ({
        meta: [{ title: 'Outreach Observability | Phoebe Admin' }],
    }),
});
